import type { GoalsState, LazyGoalsState } from './types';

export const RESET = 'state.domain.issue-goals.RESET' as const;

export type ResetAction = {
	type: typeof RESET;
	payload: GoalsState;
};

export const reset = (payload: GoalsState): ResetAction => ({
	type: RESET,
	payload,
});

export const SET_LAZY_GOALS_STATE = 'state.domain.issue-goals.SET_LAZY_GOALS_STATE' as const;

export type SetLazyGoalsStateAction = {
	type: typeof SET_LAZY_GOALS_STATE;
	payload: LazyGoalsState;
};

export const setLazyGoalsState = (payload: LazyGoalsState): SetLazyGoalsStateAction => ({
	type: SET_LAZY_GOALS_STATE,
	payload,
});
